import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import MenuItems from "./MenuItems";
import Topbar from "./Topbar";

// Removed logo imports - using text logo instead
import Shape from "../../assets/img/offcanvas/offcanvas-shape-1.jpg";

const Header = (props) => {
  const { headerClass, parentMenu, topbarEnable } = props;

  const [menuOpen, setMenuOpen] = useState(false);
  const [offCanvasOpen, setOffCanvasOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Sticky is displayed after scrolling for 100 pixels
    const toggleVisibility = () => {
      if (window.pageYOffset > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {topbarEnable ? <Topbar /> : ""}

      <header>
        <div
          id="header-sticky"
          className={`${
            headerClass
              ? headerClass
              : "header__area header__transparent header__space header__plr"
          } ${isVisible ? "header-sticky" : ""}`}
        >
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-xl-3 col-lg-3 col-7 col-md-6">
                <div className="header__logo">
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        width: "45px",
                        height: "45px",
                        background: `linear-gradient(135deg, #FFDC60 0%, #FFB800 100%)`,
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "16px",
                        fontWeight: "800",
                        color: "#232323",
                        boxShadow: `0 8px 25px rgba(255, 220, 96, 0.4), 
                                  0 4px 10px rgba(0, 0, 0, 0.1),
                                  inset 0 1px 0 rgba(255, 255, 255, 0.3)`,
                        border: "2px solid #232323",
                        transform: "rotate(-5deg)",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <span
                        style={{
                          transform: "rotate(5deg)",
                          letterSpacing: "-1px",
                        }}
                      >
                        AM
                      </span>
                      {/* Decorative corner accent */}
                      <div
                        style={{
                          position: "absolute",
                          top: "-3px",
                          right: "-3px",
                          width: "12px",
                          height: "12px",
                          background: "#232323",
                          borderRadius: "50%",
                        }}
                      ></div>
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: "1.4rem",
                          fontWeight: "700",
                          color: "#232323",
                          lineHeight: "1.2",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        Ayush
                      </div>
                      <div
                        style={{
                          fontSize: "1.4rem",
                          fontWeight: "300",
                          color: "#FFDC60",
                          lineHeight: "1.2",
                          marginTop: "-2px",
                          letterSpacing: "-0.5px",
                          textShadow: "1px 1px 0 #232323",
                        }}
                      >
                        Mishra
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-xl-6 col-lg-7 d-none d-lg-block">
                <div className="header__main-menu text-xxl-end text-center">
                  <nav id="mobile-menu">
                    <ul>
                      <MenuItems parentMenu={parentMenu} />
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="col-xl-3 col-lg-2 col-5 col-md-6">
                <div className="header__action d-flex justify-content-end">
                  <Link
                    className="main-btn-sm d-none d-xl-block tp-btn-hover alt-color"
                    to="/contact"
                  >
                    <span>Get In Touch</span>
                    <b></b>
                  </Link>
                  <div className="header__menu-bar">
                    <button
                      onClick={() => {
                        setOffCanvasOpen(true);
                      }}
                      className={menuOpen ? "it-menu-bar open" : "it-menu-bar"}
                    >
                      <i className="far fa-bars"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="it-offcanvas-area">
        <div className={offCanvasOpen ? "itoffcanvas opened" : "itoffcanvas"}>
          <div className="it-offcanva-bottom-shape d-none d-xxl-block">
            <img src={Shape} alt="" />
          </div>
          <div className="itoffcanvas__close-btn">
            <button
              onClick={() => {
                setOffCanvasOpen(false);
              }}
              className="close-btn"
            >
              <i className="fal fa-times"></i>
            </button>
          </div>
          <div className="itoffcanvas__logo">
            <Link
              to="/"
              style={{
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "55px",
                  height: "55px",
                  background: `linear-gradient(135deg, #FFDC60 0%, #FFB800 100%)`,
                  borderRadius: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#232323",
                  boxShadow: `0 10px 30px rgba(255, 220, 96, 0.5), 
                            0 6px 15px rgba(0, 0, 0, 0.2),
                            inset 0 1px 0 rgba(255, 255, 255, 0.4)`,
                  border: "3px solid white",
                  transform: "rotate(-5deg)",
                  transition: "all 0.3s ease",
                }}
              >
                <span
                  style={{
                    transform: "rotate(5deg)",
                    letterSpacing: "-1px",
                  }}
                >
                  AM
                </span>
                {/* Decorative corner accent */}
                <div
                  style={{
                    position: "absolute",
                    top: "-4px",
                    right: "-4px",
                    width: "15px",
                    height: "15px",
                    background: "white",
                    borderRadius: "50%",
                  }}
                ></div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "1.6rem",
                    fontWeight: "700",
                    color: "white",
                    lineHeight: "1.2",
                    letterSpacing: "-0.5px",
                  }}
                >
                  Ayush
                </div>
                <div
                  style={{
                    fontSize: "1.6rem",
                    fontWeight: "300",
                    color: "#FFDC60",
                    lineHeight: "1.2",
                    marginTop: "-2px",
                    letterSpacing: "-0.5px",
                    textShadow: "1px 1px 0 rgba(0, 0, 0, 0.5)",
                  }}
                >
                  Mishra
                </div>
              </div>
            </Link>
          </div>
          <div className="itoffcanvas__text">
            <p>
              I specialize in creating custom React & React Native applications
              that streamline business operations and increase efficiency.
            </p>
          </div>
          <div
            className={
              innerWidth < 992 ? "mobile-menu mean-container" : "d-none"
            }
          >
            <div className="mean-bar">
              <nav className="mean-nav">
                <ul>
                  <MenuItems />
                </ul>
              </nav>
            </div>
          </div>
          <div className="itoffcanvas__info">
            <h3 className="offcanva-title">Get In Touch</h3>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="mailto:ayushmishra7352@gmail.com">
                  <i className="fal fa-envelope"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Email</span>
                <a href="mailto:ayushmishra7352@gmail.com">
                  ayushmishra7352@gmail.com
                </a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="tel:+918802487352">
                  <i className="fal fa-phone-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Phone</span>
                <a href="tel:+918802487352">+91 8802487352</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fas fa-map-marker-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Location</span>
                <a href="#" target="_blank">
                  Delhi, India
                </a>
              </div>
            </div>
          </div>
          <div className="itoffcanvas__social">
            <div className="social-icon">
              <a href="#">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="#">
                <i className="fab fa-github"></i>
              </a>
              <a href="#">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {offCanvasOpen ? (
        <div
          className="body-overlay apply"
          onClick={() => {
            setOffCanvasOpen(false);
          }}
        ></div>
      ) : (
        <div className="body-overlay"></div>
      )}
    </>
  );
};

export default Header;
